import { render, staticRenderFns } from "./Agrupadorprogramas.vue?vue&type=template&id=fb32086a"
import script from "./Agrupadorprogramas.vue?vue&type=script&lang=js"
export * from "./Agrupadorprogramas.vue?vue&type=script&lang=js"
import style0 from "./Agrupadorprogramas.vue?vue&type=style&index=0&id=fb32086a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports